import { render, staticRenderFns } from "./NonSeat.vue?vue&type=template&id=08628e88"
import script from "./NonSeat.vue?vue&type=script&lang=js"
export * from "./NonSeat.vue?vue&type=script&lang=js"
import style0 from "./NonSeat.vue?vue&type=style&index=0&id=08628e88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports